import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import PartnershipsExpandedNav from './PartnershipsExpandedNav';
import PartnershipsNav from './PartnershipsNav';

const PartnershipsHeader = ({ backgroundImage, children, colors, logo }) => {
  const [open, setOpen] = useState(false);

  // handle expanded nav
  useEffect(() => {
    const ref = document.querySelector('body');

    if (ref) {
      if (open) {
        ref.style.position = 'fixed';
        window.scrollTo({ behavior: 'smooth', top: 0 });
      } else {
        ref.style.position = 'relative';
      }
    }
  }, [open]);

  return (
    <div
      className="partnerships-header"
      style={
        colors && colors.background
          ? { backgroundColor: colors.background }
          : null
      }
    >
      <PartnershipsNav colors={colors} open={open} setOpen={setOpen} />
      <PartnershipsExpandedNav open={open} />
      {children}
      {backgroundImage && (
        <GatsbyImage
          className="partnerships-header__background-image"
          image={backgroundImage}
          style={{ position: 'absolute' }}
        />
      )}
      {logo && <div className="partnerships-header__logo">{logo}</div>}
    </div>
  );
};

PartnershipsHeader.propTypes = {
  backgroundImage: PropTypes.object,
  colors: PropTypes.object,
  logo: PropTypes.element,
};

export default PartnershipsHeader;
